import React from 'react';
import { Text, View } from 'react-native';
import { ThemeColors } from '@/src/context/ThemeContext';
import { BlogPost } from '@/src/domain/models/BlogPost';

const ProContent: React.FC<{ colors: ThemeColors }> = ({ colors }) => (
  <View>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Tournaly has always been free for casual use, and that isn't changing. But for organizers
      who run serious competitions — clubs, gaming communities, esports teams — we're introducing
      Tournaly Pro: a subscription that removes every limit and adds professional-grade tools.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      What's included in Pro
    </Text>
    {[
      'Unlimited active tournaments (free plan: 3)',
      'Up to 512 participants per tournament (free plan: 16)',
      'All 6 bracket formats including Double Elimination, Swiss, and King of the Hill',
      'Unlimited active leagues (free plan: 1)',
      'PDF export of brackets and standings — shareable, printable, professional',
      'No Tournaly watermark on exports',
      'No ads across the entire app',
      'PRO badge on your profile',
    ].map((item, index) => (
      <View key={index} style={{ flexDirection: 'row', marginBottom: 10, alignItems: 'flex-start' }}>
        <Text style={{ color: colors.primary, marginRight: 10, fontSize: 16 }}>•</Text>
        <Text style={{ fontSize: 15, lineHeight: 23, color: colors.textSecondary, flex: 1 }}>{item}</Text>
      </View>
    ))}

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 24 }}>
      Pricing
    </Text>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Tournaly Pro is €4.99/month or €39.99/year (save 33%). You can subscribe from the
      "Tournaly Pro" section in the navigation drawer, or from the paywall that appears
      when you reach a free plan limit.
    </Text>

    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.textSecondary }}>
      The free plan remains exactly as it is — no features removed, no time limits.
      Pro is for those who need more scale and polish.
    </Text>
  </View>
);

const ProContentEs: React.FC<{ colors: ThemeColors }> = ({ colors }) => (
  <View>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Tournaly siempre ha sido gratuito para uso casual, y eso no cambia. Pero para los
      organizadores que gestionan competiciones serias — clubs, comunidades de gaming, equipos
      de esports — presentamos Tournaly Pro: una suscripción que elimina todos los límites
      y añade herramientas de nivel profesional.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      Qué incluye Pro
    </Text>
    {[
      'Torneos activos ilimitados (plan gratuito: 3)',
      'Hasta 512 participantes por torneo (plan gratuito: 16)',
      'Los 6 formatos de bracket incluyendo Doble Eliminación, Suizo y King of the Hill',
      'Ligas activas ilimitadas (plan gratuito: 1)',
      'Exportación PDF de brackets y clasificaciones — compartible, imprimible, profesional',
      'Sin marca de agua de Tournaly en las exportaciones',
      'Sin anuncios en toda la app',
      'Insignia PRO en tu perfil',
    ].map((item, index) => (
      <View key={index} style={{ flexDirection: 'row', marginBottom: 10, alignItems: 'flex-start' }}>
        <Text style={{ color: colors.primary, marginRight: 10, fontSize: 16 }}>•</Text>
        <Text style={{ fontSize: 15, lineHeight: 23, color: colors.textSecondary, flex: 1 }}>{item}</Text>
      </View>
    ))}

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 24 }}>
      Precios
    </Text>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Tournaly Pro cuesta €4,99/mes o €39,99/año (ahorra un 33%). Puedes suscribirte desde
      la sección "Tournaly Pro" en el menú de navegación, o desde el paywall que aparece
      cuando alcanzas un límite del plan gratuito.
    </Text>

    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.textSecondary }}>
      El plan gratuito sigue exactamente igual — sin features eliminadas, sin límites de tiempo.
      Pro es para quienes necesitan más escala y acabado profesional.
    </Text>
  </View>
);

export const post: BlogPost = {
  slug: '2026-02-17-tournaly-pro',
  title: 'Introducing Tournaly Pro',
  titleEs: 'Presentamos Tournaly Pro',
  date: '2026-02-17',
  summary: 'Tournaly Pro unlocks unlimited tournaments, 512 participants per bracket, all 6 formats including Swiss and Double Elimination, PDF export, and a completely ad-free experience.',
  summaryEs: 'Tournaly Pro desbloquea torneos ilimitados, 512 participantes por bracket, los 6 formatos incluyendo Suizo y Doble Eliminación, exportación PDF y una experiencia sin anuncios.',
  tags: ['Pro', 'Subscription'],
  Content: ProContent,
  ContentEs: ProContentEs,
};
